import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import { GenericTag } from "@ui-components/Tag/GenericTag";
import { carriersAdminText } from "./carriersLabels";
import { CarrierResponse } from "./request/request";

const text = carriersAdminText;

/** One row of the Carriers table: display-ready values plus the raw record. */
export interface CarrierRow {
  id: number;
  name: string;
  codeLabel: string;
  available: boolean;
  serviceCount: number;
  raw: CarrierResponse;
}

export function shapeCarrierRows(carriers: CarrierResponse[]): CarrierRow[] {
  return carriers.map((carrier) => ({
    id: carrier.id,
    name: carrier.name,
    codeLabel: carrier.code || text.noCode,
    available: carrier.available,
    serviceCount: carrier.serviceCount ?? 0,
    raw: carrier,
  }));
}

/**
 * Which dialog the Delete action opens. A carrier the list already shows in
 * use goes straight to "can't be deleted · Deactivate": the plain confirm
 * says no service uses it, which would be false. The backend's 409 still
 * guards a count that changed since the list loaded.
 */
export function deleteDialogFor(row: CarrierRow): "confirm" | "in-use" {
  return row.serviceCount > 0 ? "in-use" : "confirm";
}

export const carrierColumns: GenericTableColumn<CarrierRow>[] = [
  { header: text.columns.name, accessor: "name" },
  { header: text.columns.code, accessor: "codeLabel" },
  {
    header: text.columns.available,
    accessor: "available",
    sortAccessor: (row) => (row.available ? 1 : 0),
    renderCell: (row) => (
      <GenericTag
        label={row.available ? text.available.yes : text.available.no}
        variant={row.available ? "success" : "neutral"}
        size="small"
      />
    ),
  },
  { header: text.columns.services, accessor: "serviceCount" },
];
